import { client2 } from "@/config/axios-wrapper";

export const getAllPackages = async (userType: "employer" | "jobseeker") => {
  const response = await client2.get(`/background-check/packages?user=${userType}`);
  return response.data;
};

export const getPackgageById = async (id: string) => {
  const response = await client2.get(`/background-check/packages/${id}`);
  return response.data;
};

export const getPurchaseHistory = async (userType: string, userId: string) => {
  return await client2.get(`/${userType}/${userId}/bc-purchase-history`);
};

import axios from "axios";

export interface ApplicationData {
  package_id: string;
  first_name: string;
  middle_name?: string;
  last_name: string;
  social_security_no: number;
  dob: Date;
  email: string;
  address: {
    country_code: string;
    state_code: string;
    city: string;
    address1: string;
    postal_code: string;
  };
  phone: string;
}

export const submitApplication = async (data: ApplicationData) => {
  const response = await client2.post("/background-check/bc-applications", data);
  return response.data;
};

export const createCheckoutSession = async (payload: {
  pkg_id?: string;
  bc_application_id: string;
  success_url: string;
}) => {
  try {
    const response = await client2.post(
      "/background-check/bc-applications/create-checkout-session",
      payload,
    );
    return response.data;
  } catch (error: any) {
    console.error("Error creating checkout session:", error);
    throw new Error(error.response?.data?.message || "Failed to create checkout session");
  }
};

export const getAllJobseekerBcApplications = async (userId: string) => {
  const response = await client2.get(`/jobseekers/${userId}/bc-applications`);
  return response.data;
};

export const getApplicationById = async (applicationId: string) => {
  const response = await client2.get(`/background-check/bc-applications/${applicationId}`);
  return response.data;
};

export const shareReport = async (data: { bc_application_id: string; chat_ids: string[] }) => {
  const response = await client2.post("/background-check/bc-shared-applications", data);
  return response.data;
};

export const getShareableChats = async ({ queryKey }: { queryKey: string[] }) => {
  const [, searchQuery] = queryKey; // Extract the searchQuery from queryKey
  const response = await client2.get(
    `/background-check/shareable-chats?skip=0&limit=200&q=${searchQuery || ""}`,
  );
  return response.data;
};
export const getShareApplicationHistory = async (jobseekerId: string, applicationId: string) => {
  const response = await client2.get(
    `jobseekers/${jobseekerId}/bc-shared-histories?bc_application_id=${applicationId}`,
  );
  return response.data;
};

export const getShareableApplications = async (jobseekerId: string) => {
  const response = await client2.get(`/jobseekers/${jobseekerId}/shareable-bc-applications`);
  return response.data;
};

export const requestBcReport = async (data: { bc_application_ids: string[] }) => {
  const response = await client2.post("/background-check/bc-report-requests", data);
  return response.data;
};

export const acceptReportRequestById = async (reportRequestId: string) => {
  const response = await client2.post(
    `/background-check/bc-report-requests/${reportRequestId}/accept`,
  );
  return response.data;
};
export const declineReportRequestById = async (reportRequestId: string) => {
  const response = await client2.post(
    `/background-check/bc-report-requests/${reportRequestId}/decline`,
  );
  return response.data;
};

export const getAllOrginzationBcApplications = async (orgId: string) => {
  const response = await client2.get(`/organizations/${orgId}/bc-shared-applications `);
  return response.data;
};

export const getAllOrginzationBcReportRequests = async (orgId: string) => {
  const response = await client2.get(`/organizations/${orgId}/bc-report-requests`);
  return response.data;
};

export const getAllOrginzationBcRequests = async (orgId: string) => {
  const response = await client2.get(`/organizations/${orgId}/bc-requests`);
  return response.data;
};

export const createBCRequest = async (payload: { chat_ids: string[]; pkg_id: string }) => {
  const response = await client2.post("/background-check/bc-requests-2", payload);
  return response.data;
};

export const getJobseekerBcCompliance = async (userId: string) => {
  const response = await client2.get(`/jobseekers/${userId}/bc-document`, {
    responseType: "blob",
  });
  return response.data;
};

export const getOrgBcCompliance = async (orgId: string) => {
  const response = await client2.get(`/organizations/${orgId}/bc-document`, {
    responseType: "blob",
  });
  return response.data;
};
export const downloadBcComplianceDoc = async (id: string, userName: string, user_type: string) => {
  try {
    let fileData;
    if (user_type === "job_seeker") {
      fileData = await getJobseekerBcCompliance(id);
    } else {
      fileData = await getOrgBcCompliance(id);
    }

    const fileURL = window.URL.createObjectURL(new Blob([fileData]));

    const a = document.createElement("a");
    a.href = fileURL;
    a.download = `compliance-document.docx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};

export const getBcRequestById = async (id: string) => {
  const response = await client2.get(`/background-check/bc-requests/${id}`);
  return response.data;
};

export const sendInviteForBcRequest = async (data: { emails: string[]; pkg_id: string }) => {
  const response = await client2.post("/background-check/invite", data);
  return response.data;
};

export const createBCRequestByJobseekerIds = async (data: {
  jobseeker_ids: string[];
  pkg_id: string;
}) => {
  const response = await client2.post("/background-check/bc-requests-by-jobseeker-ids", data);
  return response.data;
};
